import { executeRequest, Request } from '@jfs/network'
import { getEncryptedPwdAndKey } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const getLoginRequestBody = (emailId: string, pwd: string) => {
  const encPwdNKey = getEncryptedPwdAndKey(pwd)
  return {
    user: {
      mobile: {
        mobileNumber: '1234567890',
        countryCode: '91',
      },
      emailAddress: emailId,
    },
    authenticateList: [
      {
        mode: 13,
        value: encPwdNKey?.password ?? '',
      },
    ],
    scope: 'SESSION',
    purpose: '2',
    secure: {
      encryptionKey: encPwdNKey?.key ?? '',
    },
  }
}

const loginRequest = (emailId: string, pwd: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.userAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: getLoginRequestBody(emailId, pwd),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { loginRequest }
